// extracted by mini-css-extract-plugin
export default {"whyUsCard":"WhyUsCard_whyUsCard__A3alm","picture":"WhyUsCard_picture__qsK3y"};